// Newsletter CTA
export var ANONYMOUS_SUBSCRIBE_URL = '/api/NewsletterSubscription/AnonymousSubscribeToNewsletter';
export var KNOWN_SUBSCRIBE_URL = '/api/NewsletterSubscription/UpdateNewsletterSubscription';
export var ACTIVITY_UPDATE_URL = '/api/NewsletterSubscription/ProgramActivityUpdate';
export var REG_ACTION_PARAM = 'RegAction';
export var ANALYTICS_OPT_IN_EVENT = 'NewsletterOptIn';
export var ANALYTICS_DUPLICATE_EVENT = 'DuplicateSubscriptions';
export var ANALYTICS_INTERSTITIAL_VIEW_EVENT = 'InterstitialView';
export var ANALYTICS_INTERSTITIAL_CLOSE_EVENT = 'InterstitialClose';
export var MAX_NUM_NEWSLETTERS = 4; // Social Account Link

export var SOCIAL_ADD_URL = '/api/FederatedAccount/AddReference';
export var SOCIAL_REMOVE_URL = '/api/FederatedAccount/RemoveReference';
export var SOCIAL_PROVIDER_TYPE = {
  Facebook: 0,
  Google: 1
}; // REGEX

export var EMAIL_REGEX = /^((\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)\s*)+$/;
export var ZIP_CODE_REGEX = /^[0-9]{5}-?[0-9]{4}$|^[0-9]{5}$/;